// import React from "react";
// import ItemList from "./restaurant/ItemList";
// import { useDispatch, useSelector } from "react-redux";
// import { clearCart } from "./utils/slice/cartSlice";

// const Cart = () => {
//   const cartItems = useSelector((store) => store.cart.items);
//   const dispatch = useDispatch();
//   const handleClearCart = () => {
//     dispatch(clearCart());
//   };

//   // Calculate the total price of items in the cart
//   const totalPrice = cartItems.reduce((total, cartItem) => {
//     const price =
//       cartItem?.card?.info?.price / 100 ||
//       cartItem?.card?.info?.defaultPrice / 100;
//     return total + (price || 0);
//   }, 0);
//   return (
//     <div className="text-center m-4 p-4">
//       <h1 className="text-decor text-2xl font-bold">Your Cart</h1>
//       <div className="w-6/12 m-auto mt-4">
//         {cartItems.length > 0 && (
//           <button
//             className="text-decor text-white bg-slate-950 py-1 px-2 rounded-xl "
//             onClick={handleClearCart}
//           >
//             Clear Cart
//           </button>
//         )}
//         {cartItems.length === 0 && (
//           <h1 className="text-decor my-3 p-2 text-2xl">
//             "No snacks, no treats—your cart’s feeling the hunger! 🍩🍭 Fill it
//             up with something tasty and make it happy!"
//           </h1>
//         )}
//         <ItemList items={cartItems} />
//       </div>
//       {/* Display Total Price */}
//       <div className="mt-9 m-auto w-6/12 px-4 py-2 text-right  bg-slate-300 rounded-lg">
//         <p className="text-decor text-lg font-bold">
//           Total Price: ₹ {totalPrice.toFixed(2)}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Cart;

import React from "react";
import ItemList from "./restaurant/ItemList";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "./utils/slice/cartSlice";

const Cart = () => {
  const cartItems = useSelector((store) => store.cart.items);
  const dispatch = useDispatch();

  const handleClearCart = () => {
    dispatch(clearCart());
  };

  // Calculate the total price of items in the cart
  const totalPrice = cartItems.reduce((total, cartItem) => {
    const price =
      cartItem?.card?.info?.price / 100 ||
      cartItem?.card?.info?.defaultPrice / 100;
    return total + (price || 0);
  }, 0);

  return (
    <div className="text-center m-4 p-4">
      <h1 className="text-decor text-2xl font-bold">Your Cart</h1>
      <div className="w-6/12 m-auto mt-4">
        {cartItems.length > 0 && (
          <button
            className="text-decor text-white bg-slate-950 py-1 px-2 rounded-xl "
            onClick={handleClearCart}
          >
            Clear Cart
          </button>
        )}
        {cartItems.length === 0 && (
          <h1 className="text-decor my-3 p-2 text-2xl">
            "No snacks, no treats—your cart’s feeling the hunger! 🍩🍭 Fill it
            up with something tasty and make it happy! "
          </h1>
        )}
        <ItemList items={cartItems} showRemove={true} />
      </div>
      {/* Display Total Price */}
      {cartItems.length > 0 && (
        <div className="mt-9 m-auto w-6/12 px-4 py-2 text-right  bg-slate-300 rounded-lg">
          <p className="text-decor text-lg font-bold">
            Total Price: ₹ {totalPrice.toFixed(2)}
          </p>
        </div>
      )}
    </div>
  );
};

export default Cart;
